import React, { Component, Fragment } from "react";
import { Menu, Segment, Image, Dropdown, Responsive } from "semantic-ui-react";
import { Redirect } from "react-router-dom";
import fire from "../config/config";

export default class Heading extends Component {
  state = {
    activeItem: "home",
    redirect: false,
    whereTo: "",
    loggedIn: false
  };

  componentDidMount() {
    fire.auth().onAuthStateChanged(user => {
      if (user != null) {
        this.setState({ loggedIn: true });
      }
    });
  }

  handleItemClick = (e, { name }) => {
    /*if (name === 'About Us'){
      this.setState({ activeItem: name,
        redirect:true,
        whereTo:'https://thebillioncoin.info/tbc_formula.php' });
    }*/
    /*if (name === 'BTC Price'){
      this.setState({ activeItem: name,
        redirect:true,
        whereTo:'https://kringle.cash/admin/currency_calculator.php' });
    }*/
    if (name === "Login") {
      this.setState({
        activeItem: name,
        redirect: true,
        whereTo: "/login"
      });
    }
    if (name === "Dashboard") {
      this.setState({
        activeItem: name,
        redirect: true,
        whereTo: "/dashboard"
      });
    }
    if (name === "home") {
      this.setState({
        activeItem: name,
        redirect: true,
        whereTo: "/"
      });
    }

    if (name === "Log out") {
      //log out
      fire.auth().signOut();
      this.setState({
        activeItem: name,
        redirect: true,
        whereTo: "/"
      });
    }

    this.setState({ activeItem: name });
  };

  render() {
    const { activeItem, redirect, whereTo, loggedIn } = this.state;

    if (redirect) {
      return <Redirect to={whereTo} />;
    }

    return (
      <Segment inverted>
        <Menu inverted fixed="top" size="large" stackable>
          <Image
            src="https://news.bitcoin.com/wp-content/uploads/2018/08/bitcoin-3263691_1600.jpg"
            style={{ width: 50, height: 50, margin: 10 }}
          />
          <Responsive as={Menu.Item}
            {...Responsive.onlyComputer}
            name="home"
            active={activeItem === "home"}
            onClick={this.handleItemClick}
          />
          <Responsive as={Menu.Item}
            {...Responsive.onlyComputer}
            href="/about"
            name="About us"
            active={activeItem === "About TBC"}
            onClick={this.handleItemClick}
            style={{ padding: 27 }}
          />



          <Menu.Menu position="right" >
            <Dropdown item icon='list'>
              <Dropdown.Menu>

                <Responsive as={Menu.Item}
                  {...Responsive.onlyMobile}
                  name="home"
                  active={activeItem === "home"}
                  onClick={this.handleItemClick}
                />
                <Responsive as={Menu.Item}
                  {...Responsive.onlyMobile}
                  href="/about"
                  name="About us"
                  active={activeItem === "About TBC"}
                  onClick={this.handleItemClick}
                  style={{ padding: 27 }}
                />



                <Menu.Item
                  //link={true}
                  href="/support"
                  name="Support"
                  active={activeItem === "Support"}
                  onClick={this.handleItemClick}
                  style={{ padding: 27 }}
                />
                {loggedIn ? (
                  <Fragment>
                    <Menu.Item
                      name="Dashboard"
                      active={activeItem === "Dashboard"}
                      onClick={this.handleItemClick}
                    />
                    <Menu.Item
                      name="Log out"
                      active={activeItem === "Log out"}
                      onClick={this.handleItemClick}
                    />
                  </Fragment>
                ) : (
                  <Menu.Item
                    name="Login"
                    active={activeItem === "Login"}
                    onClick={this.handleItemClick}
                    style={{ marginRight: 10 }}
                  />
                )}
              </Dropdown.Menu>
            </Dropdown>
          </Menu.Menu>
        </Menu>
      </Segment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Header.js